import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=a4c7aa68&scoped=true&"
import script from "./GroupDetail.vue?vue&type=script&lang=ts&"
export * from "./GroupDetail.vue?vue&type=script&lang=ts&"
import style0 from "./GroupDetail.vue?vue&type=style&index=0&id=a4c7aa68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c7aa68",
  null
  
)

export default component.exports